export function printerTest(printer: { name?: string; type: string; ip?: string }) {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')!
  ctx.font = '28px Arial'
  ctx.fillText(`Name: ${printer.name}`, 10, 30)
  ctx.fillText(`Type:  ${printer.type}`, 10, 70)
  if (printer.ip) ctx.fillText(`IP: ${printer.ip}`, 10, 110)

  return canvas
}
